import Vue from "vue";
import VueRouter from "vue-router";
import Anasayfa from "../views/Anasayfa.vue";
// import Mesajlar from "../views/Mesajlar.vue";
// import Profil from "../views/Profil.vue";
// import Search from "../views/Search.vue";
// import Kayıt from "../views/Kayıt.vue";
// import GirisYap from "../views/GirisYap.vue";
// import Bildirimler from "../views/Bildirimler.vue";
// import Admin from "../views/Admin.vue";
// import Error from "../views/Error.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/anasayfa",
  },
  {
    path: "/anasayfa",
    name: "Anasayfa",
    component: Anasayfa,
    meta: {
      title: "Anasayfa",
      layout: "HomeLayout",
    },
  },
  {
    path: "/mesajlar",
    name: "Mesajlar",
    component: () => import("@/views/Mesajlar.vue"),
    meta: {
      title: "Mesajlar",
      layout: "HomeLayout",
    },
  },
  {
    path: "/profil",
    name: "Profil",
    component: () => import("@/views/Profil.vue"),
    meta: {
      title: "Profil",
      layout: "HomeLayout",
    },
  },
  {
    path: "/search",
    name: "Search",
    component: () => import("@/views/Search.vue"),
    meta: {
      title: "Search",
      layout: "SearchLayout",
    },
  },
  {
    path: "/kayit",
    name: "Kayıt",
    component: () => import("@/views/Kayıt.vue"),
    meta: {
      title: "Kayıt Ol",
      layout: "LoginLayout",
    },
  },
  {
    path: "/giris",
    name: "Giriş Yap",
    component: () => import("@/views/GirisYap.vue"),
    meta: {
      title: "Giriş Yap",
      layout: "LoginLayout",
    },
  },
  {
    path: "/bildirimler",
    name: "Bildirimler",
    component: () => import("@/views/Bildirimler.vue"),
    meta: {
      title: "Bildirimler",
      layout: "HomeLayout",
    },
  },
  {
    path: "/admin",
    name: "Admin",
    component: () => import("@/views/Admin.vue"),
    meta: {
      title: "Admin",
      layout: "AdminLayout",
    },
  },
  {
    path: "*",
    name: "Error",
    component: () => import("@/views/Error.vue"),
    meta: {
      title: "Error",
      layout: "ErrorLayout",
    },
  },
];

const router = new VueRouter({
  routes,
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});
router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title} / friendsquads`;
  next();
});
export default router;
